import http from "../../rest/http";

export const fetchLoginForm = async (appId: any) => {
    try {
        let headdr={"x-client-key":appId}
        
      const response = await http.get(`/v1/app/get-login-form`,headdr, true);
      return response;
    } catch (error) {
      console.error("Error in fetching  login form", error);
      throw error;
    }
  };